
import { defineComponent } from "vue";
import {
	CharactersTabs,
	LanguageChanger,
	RollDice,
	SaveLoad,
} from "@/features";

export default defineComponent({
	name: "SheetHeader",
	components: { CharactersTabs, RollDice, LanguageChanger, SaveLoad },
	emits: ["character-loaded", "clear"],
});
